// extracted by mini-css-extract-plugin
export default {"editButton":"salaryHold_editButton__tky+9","TableBody":"salaryHold_TableBody__-HFrj"};